import { createAction } from "../helpers";
import { WizardActionType } from "./wizard.types";

export const nextStep = () => createAction(WizardActionType.NextStep);

export const previousStep = () => createAction(WizardActionType.PreviousStep);

export const goToStep = (step: number) =>
    createAction(WizardActionType.GoToStep, { step });

export const setState = <T>(newState: Partial<T>) =>
    createAction(WizardActionType.SetState, { newState });

export const reset = <T>(payload: { initialState: T; steps: Array<any> }) =>
    createAction(WizardActionType.Reset, payload);

export type UseWizardAction<T> =
    | ReturnType<typeof nextStep>
    | ReturnType<typeof previousStep>
    | ReturnType<typeof goToStep>
    | ReturnType<typeof setState<T>>
    | ReturnType<typeof reset<T>>;
